module.exports = __webpack_public_path__ + "static/pro-pic-ed4d97845599eb552fc0c57a57e3f5f5.jpeg";